/* eslint-disable class-methods-use-this, import/no-extraneous-dependencies */
import useJwt from '@/auth/jwt/useJwt'

export default class SpiderJobService {
  static list(filters) {
    let params = {}
    if (filters !== undefined) {
      params = Object.fromEntries(Object.entries(filters).filter(filter => filter[1] !== '' && filter[1] !== 'all'))
    }

    params.order_by = params.sortBy + (params.sortDesc ? ' DESC' : '')
    delete params.sortDesc
    delete params.sortBy

    return useJwt.get('/spider/jobs', params)
  }

  static test(id) {
    return useJwt.get('/spider/job-test', { id })
  }

  static listTags() {
    return useJwt.get('/spider/tags')
  }

  static getJob(id) {
    return useJwt.get('/spider/job', { id })
  }

  static saveJob(data) {
    return useJwt.post('/spider/job', {}, data)
  }

  static deleteJob(id) {
    return useJwt.delete('/spider/job', { id })
  }
}
